// extracted by mini-css-extract-plugin
export default {"uploadDocumentSection":"UploadForm_uploadDocumentSection__tY4zJ","uploadText":"UploadForm_uploadText__OIwuQ"};